// extracted by mini-css-extract-plugin
export default {"regions":"PMGsbM","regions-group":"BqBgQ1","region-list":"hmt2sY","region-list__item":"nkFWuP","region-list__link":"bl9YTF","group-title":"MFbrDv"};